module.exports = __webpack_public_path__ + "img/banner-img@2x.96b58038.webp";